export default {
    enemy: {
        size: 9,
        level: {
            min: 4,
            max: 20,
        },
    },
    notification: {
        ms: 3 * 1000,
    },
    player: {
        death: {
            ms: 5 * 1000,
            repeat: 4,
        },
    },
    time: {
        repeat: 1000000 * 60,
    },
};
